import axios from 'axios';

import { ApiResponse } from '../../models/api.response.model';
import { authToken } from '../../scripts/authentication.script';

export class ProviderQuoteDA {
  static apiResponse: ApiResponse

  public static async getProviderQuotes(
    id_company: string,
    status: string,
    sort_field: string,
    sort_mode: string,
    page: number = 1,
    limit: number = 20,
    search: string = '',
    all: boolean = false
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-quotes?status=${status}&sort_by=${sort_field}&sort_order=${sort_mode}${all ? '&all=true' : `&page=${page}&limit=${limit}`}${search ? `&search=${encodeURIComponent(search)}` : ''}`
    let config: any = { headers: { Authorization: authToken() } }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async getProviderQuote(
    id_company: string,
    id_provider_quote: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-quotes/${id_provider_quote}`
    let config: any = { headers: { Authorization: authToken() } }

    await axios.get(url, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async acceptProviderQuote(
    id_company: string,
    id_provider_quote: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-quotes/${id_provider_quote}/accept`
    let config: any = { headers: { Authorization: authToken() } }

    await axios.post(url, {}, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async declineProviderQuote(
    id_company: string,
    id_provider_quote: string,
    reason: string = ''
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-quotes/${id_provider_quote}/decline`
    let config: any = { headers: { Authorization: authToken() } }

    await axios.post(url, { reason }, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async updateInternalNotes(
    id_company: string,
    id_provider_quote: string,
    notes: string
  ): Promise<ApiResponse> {
    let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-quotes/${id_provider_quote}/notes`
    let config: any = { headers: { Authorization: authToken() } }

    await axios.put(url, { internal_notes: notes }, config).then(response => {
      this.apiResponse = {
        status: response.status,
        message: response.statusText,
        data: response.data?.data ?? response.data
      }
    }).catch(error => {
      this.apiResponse = {
        status: error.response?.status ?? 500,
        message: error.response?.statusText ?? 'Error',
        data: error.response?.data?.error ?? { code: 'NETWORK_ERROR', message: error.message }
      }
    })

    return this.apiResponse
  }

  public static async attachVoucher(id_company: string, id_provider_quote: string, body: { id_document_inbox: string, role?: string }): Promise<any> {
    try {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-quotes/${id_provider_quote}/vouchers`
      let config: any = { headers: { Authorization: authToken() } }
      const response = await axios.post(url, body, config)
      return { status: response.status, data: response.data?.data ?? response.data }
    } catch (error: any) {
      return { status: error.response?.status ?? 500, data: error.response?.data ?? {} }
    }
  }

  public static async uploadVoucher(id_company: string, id_provider_quote: string, file: File, role?: string): Promise<any> {
    try {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-quotes/${id_provider_quote}/vouchers/upload`
      const formData = new FormData()
      formData.append('file', file)
      formData.append('source', 'web')
      if (role) formData.append('role', role)
      let config: any = { headers: { Authorization: authToken(), 'Content-Type': 'multipart/form-data' } }
      const response = await axios.post(url, formData, config)
      return { status: response.status, data: response.data?.data ?? response.data }
    } catch (error: any) {
      return { status: error.response?.status ?? 500, data: error.response?.data ?? {} }
    }
  }

  public static async deleteVoucher(id_company: string, id_provider_quote: string, index: number): Promise<any> {
    try {
      let url: string = `${process.env.REACT_APP_PORT_ADMIN}/${id_company}/provider-quotes/${id_provider_quote}/vouchers/${index}`
      let config: any = { headers: { Authorization: authToken() } }
      const response = await axios.delete(url, config)
      return { status: response.status, data: response.data?.data ?? response.data }
    } catch (error: any) {
      return { status: error.response?.status ?? 500, data: error.response?.data ?? {} }
    }
  }
}
